import { config } from "./config";

class Storage {
	getItem<T>(itemName: string): T | null {
		try {
			const auth = localStorage.getItem(config.prefix + itemName);
			if (auth === null) {
				// Return null if the item does not exist
				return null;
			}
			return JSON.parse(auth) as T;
		} catch (error) {
			console.error(
				`Failed to parse storage item ${config.prefix + itemName}:`,
				error,
			);
			return null;
		}
	}

	setItem(itemName: string, item: any): void {
		localStorage.setItem(config.prefix + itemName, JSON.stringify(item));
	}

	removeItem(itemName: string): void {
		localStorage.removeItem(config.prefix + itemName);
	}

	clearAll(): void {
		localStorage.clear();
	}
}

const storage = new Storage();

export { storage };
